module.exports = __webpack_public_path__ + "static/media/U1-T2-2-2e.51c7e38c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-2e.svg
// module id = 544
// module chunks = 0